import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BitacoraService {

  private ENDPOINT = environment.ENDPOINTS.BITACORA;

  constructor(
    private http: HttpClient
  ) { }

  saveSobranteFondo(data: any) {
    return this.http.post<any>(`${ this.ENDPOINT }/save-sobrante-fondo`, data);
  }

  saveArqueoFondo( data: any ) {
    return this.http.post<any>(`${ this.ENDPOINT }/save-arqueo-fondo`, data);
  }

  saveBitacora( data: any ) {
    return this.http.post<any>(`${ this.ENDPOINT }`, data);
  }

  busquedaBitacora( data: any ) {
    return this.http.post<any>(`${ this.ENDPOINT }/busqueda-bitacora`, data);
  }

  getBitacoras( ) {
    return this.http.get<any>(`${ this.ENDPOINT }`);
  }

}
